import Colorant from "./Colorant";

/**
 * @class ManualColorant
 */
export default class ManualColorant extends Colorant {
    /**
     * @param {Number} id
     * @param {String} name
     * @param {String} displayName
     * @param {String} rgb
     * @param {Number} amount
     * @param {String} amountType
     * @param {Number} density
     * @param {String} ufi
     * @param {Number} validationResult
     * @param {String} warningText
     * @param {Number} dispensingLogic
     * @param {Number} correction
     * @param {Number} realAmount
     * @param {String} pump1
     * @param {String} pump2
     */
    constructor(
        id,
        name,
        displayName,
        rgb,
        amount,
        amountType,
        density,
        ufi,
        validationResult,
        warningText,
        dispensingLogic,
        correction,
        realAmount,
        pump1,
        pump2
    ) {
        super(
            id,
            name,
            displayName,
            rgb,
            amount,
            amountType,
            density,
            ufi,
            validationResult,
            warningText,
            dispensingLogic,
            correction,
            realAmount
        );

        this._pump1 = pump1;
        this._pump2 = pump2;
    }

    /**
     * @return {String}
     */
    get pump1() {
        return this._pump1;
    }

    /**
     * @param {String} pump1
     */
    set pump1(pump1) {
        this._pump1 = pump1;
    }

    /**
     * @return {String}
     */
    get pump2() {
        return this._pump2;
    }

    /**
     * @param {String} pump2
     */
    set pump2(pump2) {
        this._pump2 = pump2;
    }

    /**
     * @return {String}
     */
    formatAmount() {
        if (this._pump1 === null) {
            if (this._pump2 === null) {
                return "1: 0 2: 0";
            }

            return "1: 0 2: " + this._pump2;
        }

        if (this._pump2 === null) {
            return "1: " + this._pump1 + " 2: 0";
        }

        return "1: " + this._pump1 + " 2: " + this._pump2;
    }

    /**
     * @return {String}
     */
    formatAmountType() {
        return "";
    }

    /**
     * @return {ManualColorant}
     */
    clone = () => {
        return new ManualColorant(
            this._id,
            this._name,
            this._displayName,
            this._rgb,
            this._amount,
            this._amountType,
            this._density,
            this._ufi,
            this._validationResult,
            this._warningText,
            this._dispensingLogic,
            this._correction,
            this._realAmount,
            this._pump1,
            this._pump2
        );
    };
}
